import React from 'react';
import AgentConsumptionComponent from './AgentConsumption';

const AgentConsumption: React.FC = () => {
  return <AgentConsumptionComponent />;
};

export default AgentConsumption;
